import imgDnd from '../assets/images/tech-dnd.svg';
import imgForm from '../assets/images/tech-form.svg';
import imgI18next from '../assets/images/tech-i18next.svg';
import imgJwt from '../assets/images/tech-jwt.svg';
import imgMui from '../assets/images/tech-mui.svg';
import imgReact from '../assets/images/tech-react.svg';
import imgRedux from '../assets/images/tech-redux.svg';
import imgToastify from '../assets/images/tech-toastify.svg';
import imgTs from '../assets/images/tech-ts.svg';

export const TECHNOLOGIES = [
  { name: 'Typescript', image: imgTs },
  { name: 'React', image: imgReact },
  { name: 'RTK | RTK Query', image: imgRedux },
  { name: 'Material UI', image: imgMui },
  { name: 'JWT-decode', image: imgJwt },
  { name: 'React-hook-form', image: imgForm },
  { name: 'React-i18next', image: imgI18next },
  { name: 'React-Toastify', image: imgToastify },
  { name: 'React-beautiful-dnd', image: imgDnd },
];
